"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var messages_1 = require("./messages");
var traverse = function (iterable, langInfo, acc) {
    for (var key in iterable) {
        if (iterable.hasOwnProperty(key)) {
            var accumulator = acc.slice();
            accumulator.push(key);
            if (typeof iterable[key] !== 'string') {
                traverse(iterable[key], langInfo, accumulator);
            }
            else {
                var value = iterable[key];
                Object.defineProperty(langInfo, accumulator.join('.'), { value: value });
            }
        }
    }
};
/**
 * Provides mechanism to load language-specific messages for the KendoReact components.
 *
 * @param messages - An iterable object which contains key-value pairs.
 * @param languages - The language to which the messages are associated.
 */
function loadMessages(messages, language) {
    var langInfo = messages_1.messages[language] = messages_1.messages[language] || {};
    traverse(messages, langInfo, []);
}
exports.loadMessages = loadMessages;
//# sourceMappingURL=loadMessages.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-intl@3.18.0_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/@progress/kendo-react-intl/dist/npm/Localization/loadMessages.js
// module id = 6607
// module chunks = 0